module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-noya-duo-white.bb2c42bc.jpg";